import { useBrand } from '@contexts/useBrand'
import React from 'react'
import { upperCaseFirst } from '@utils/helpers/stringHelpers'

import { RadioButton } from '../baseInputs'

type Props = {
  inputLabel?: string
}

const IsCurrentOwner = ({ inputLabel, ...rest }: Props) => {
  const brand = useBrand()
  const label = inputLabel || `Do you drive a ${upperCaseFirst(brand)}?`

  return (
    <div>
      <p className="font-medium my-5">{label}</p>
      <div className="radio-btn-container flex mb-5">
        <RadioButton name="toyota_owner" label="Yes" value={true} {...rest} />
        <RadioButton name="toyota_owner" label="No" value={false} {...rest} />
      </div>
    </div>
  )
}

export default IsCurrentOwner
